"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.BmFormInfo = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _dependencyMap = require("../../dependency-map");

var _itemFactory = require("../item-engine/item-factory");

var BmFormInfo = /*#__PURE__*/function (_BmItemInfo) {
  (0, _inherits2.default)(BmFormInfo, _BmItemInfo);

  var _super = (0, _createSuper2.default)(BmFormInfo);

  function BmFormInfo(formItemInfo, parent) {
    var _this;

    (0, _classCallCheck2.default)(this, BmFormInfo);
    _this = _super.call(this, formItemInfo, parent);
    _this.options = void 0;
    _this.options = formItemInfo.options;
    if (!_this.parent) _this.dependencyMap = new _dependencyMap.DependencyMap();
    return _this;
  }

  return BmFormInfo;
}(_itemFactory.BmItemInfo);

exports.BmFormInfo = BmFormInfo;
